export { SocialInstagram as default } from './SocialInstagram';
